import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"


const DevolucionRendicionRegistroContableGridModal = ({ idDevolucionRegistroContableLote, onCancel }) => {

    const { setIsLoading } = useManagedContext()

    const [registrosContables, setRegistrosContables] = useState([])
    const [idReciboPublicacion, setIdReciboPublicacion] = useState(null)

    useEffect(() => {
        if (idDevolucionRegistroContableLote > 0) {
            SearchRegistros(idDevolucionRegistroContableLote)
        }
    }, [])

    const SearchRegistros = (id) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${id}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_REGISTRO_CONTABLE_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setRegistrosContables(data)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.devolucion?.idReciboPublicacion) {
                setIdReciboPublicacion(item.devolucion.idReciboPublicacion)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title="Registros contables de devoluciones"
            body={(
                <>
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={registrosContables}
                    avmr={avmr}
                    columns={[
                        { Header: 'Fecha de ingreso', accessor: 'fechaIngreso', Cell: (data) => getDateToString(data.value), width: '14%'},
                        { Header: 'Ejercicio', accessor: 'ejercicio', width: '7%' },
                        { Header: 'Jurisdicción', accessor: 'jurisdiccion', width: '13%' },
                        { Header: 'Recurso por rubro', accessor: 'recursoPorRubro', width: '13%' },
                        { Header: 'Cuenta contable', accessor: 'cuentaContable', width: '13%' },
                        { Header: 'Importe', accessor: 'importe', Cell: (data) => getFormatNumber(data.value, 2), width: '15%', alignCell: 'right' },
                        { Header: 'N° VEP', accessor: 'devolucion', width: '15%', Cell: ({ row }) =>  getNumeroRecibo_ObjectToIdentificador(row.original.devolucion) },
                    ]}
                    showDownloadCSV={false}
                />

                {idReciboPublicacion && (
                    <ReciboPublicacionModal
                        id={idReciboPublicacion}
                        onCancel={() => setIdReciboPublicacion(null)}
                    />
                )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default DevolucionRendicionRegistroContableGridModal
